import { useEffect } from 'react'
import { useInfiniteQuery } from '@tanstack/react-query'
import { useInView } from 'react-intersection-observer'
import { getGetLikedProductsQueryKey, getLikedProducts } from '@/apis/rest/generated/hooks'
import { PageSizeEnum } from '@/constants/page-size.enum'
import { UserContainer } from '@/containers/users/UserContainer'

export const useLikeProductList = () => {
  const { me } = UserContainer.useContainer()

  const { ref, inView: isInView } = useInView()

  // 찜한 상품 목록 조회 시 유저 아이디를 키에 추가하여 캐시 데이터 관리
  const baseKey = getGetLikedProductsQueryKey({ size: PageSizeEnum.PageSize10 })
  const queryKey = [...baseKey, me?.id]

  const {
    data: likeProductsInfiniteData,
    isSuccess,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    refetch,
    isLoading,
    isFetching,
  } = useInfiniteQuery(
    queryKey,
    ({ pageParam = PageSizeEnum.PageSize1 }) => getLikedProducts({ page: pageParam, size: PageSizeEnum.PageSize10 }),
    {
      enabled: !!me,
      retry: false,
      getNextPageParam: (lastPage) => {
        if (lastPage.page?.hasNextPage) {
          return lastPage.page.page + 1
        }
        return undefined
      },
    }
  )

  useEffect(() => {
    if (isInView && hasNextPage) {
      fetchNextPage()
    }
  }, [isInView, fetchNextPage, hasNextPage])

  return {
    ref,
    isSuccess,
    likeProductsInfiniteData,
    isFetchingNextPage,
    refetch,
    isLoading,
    isFetching,
    totalCount: likeProductsInfiniteData?.pages[0]?.page?.totalCount || 0,
  }
}
